"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockService = void 0;
const core_1 = require("@apollo/client/core");
const common_1 = require("../common");
const classes_1 = require("./classes");
class BlockService extends common_1.Service {
    async getCurrentBlockNumber() {
        let result = 1;
        const { apiService } = this.services;
        const { blockStats } = await apiService.query(core_1.gql `
        query($chainId: Int) {
          blockStats(chainId: $chainId) {
            currentBlockNumber
          }
        }
      `, {
            models: {
                blockStats: classes_1.BlockStats,
            },
        });
        if (blockStats && blockStats.currentBlockNumber) {
            result = blockStats.currentBlockNumber;
        }
        return result;
    }
}
exports.BlockService = BlockService;
